// ACTIONS
import {
  SAVE_SEARCH_DIALOG_OPEN,
  SAVE_SEARCH_DIALOG_CLOSE,
  USER_SAVED_SEARCH_DELETED,
  USER_SAVED_SEARCHES_FETCHED,
  USER_SAVED_SEARCH_REQUEST_STARTED,
} from '../actions/UserSavedSearchActions';

const getInitialState = () => {
  return {
    isFetchingUserSavedSearches: false,
    userSavedSearchesCount: 0,
    userSavedSearches: [],
    saveSearchDialogOpen: false,
  };
};

function UserSavedSearchState(state = getInitialState(), action) {
  switch (action.type) {
    case USER_SAVED_SEARCH_REQUEST_STARTED:
      return {
        ...state,
        isFetchingUserSavedSearches: action.isFetchingUserSavedSearches,
      };
    case USER_SAVED_SEARCHES_FETCHED:
      return {
        ...state,
        userSavedSearchesCount: action.userSavedSearchesReport.count,
        userSavedSearches: action.userSavedSearchesReport.saved_searches,
        isFetchingUserSavedSearches: action.isFetchingUserSavedSearches,
      };
    case USER_SAVED_SEARCH_DELETED:
      const recordIdToRemove = action.savedSearch.record_id;
      const newUserSavedSearches = state.userSavedSearches.filter(
        (search) => search.record_id !== recordIdToRemove
      );

      return {
        ...state,
        userSavedSearches: newUserSavedSearches,
        userSavedSearchesCount: (state.userSavedSearchesCount -= 1),
      };
    case SAVE_SEARCH_DIALOG_CLOSE:
      return {
        ...state,
        saveSearchDialogOpen: false,
      };
    case SAVE_SEARCH_DIALOG_OPEN:
      return {
        ...state,
        saveSearchDialogOpen: true,
      };
    default:
      return state;
  }
}

export default UserSavedSearchState;
